/* eslint react/prop-types: 0 */
import { useState, useLayoutEffect, useRef } from 'react';
import styled from '@emotion/styled';
import { tokens } from '@hotjar/hotsauce';
import { Icon } from '@hotjar/webapp/components/Icon';

const PillarContainer = styled.div`
  display: inline-block;
  background: ${tokens.color.neutral_200};
  margin-bottom: 8px;
  margin-right: 8px;
  border-radius: 2px 2px 2px 2px;
  color: ${tokens.color.text_default};
  transition: all 0.2s ease-in-out;
  transition-property: background-color;
  font-weight: normal;

  &:hover {
    background: ${tokens.color.neutral_300};
  }
`;
const PillarText = styled.span`
  padding: 3px 0 4px 8px;
  max-width: 250px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;
const PillarIcon = styled(Icon)`
  opacity: 0.2;
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
  will-change: opacity;
  transition: all 0.2s ease-in-out;
  transition-property: color, opacity;

  &:hover {
    opacity: ${({ disabled }) => (disabled ? 0.2 : 1)};
  }
`;

const PillarCloseButton = styled.span`
  margin-right: 4px;
  margin-left: 5px;
  padding: 2px 0 4px;
`;
const PillarInnerContainer = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
`;

export const Pillar = ({ children, onDelete, disabled, ...props }) => {
  const textRef = useRef(null);
  const [tooltipDisabled, setTooltipDisabled] = useState(true);
  useLayoutEffect(() => {
    const hasOverflow = textRef.current.offsetWidth < textRef.current.scrollWidth;
    setTooltipDisabled(!hasOverflow);
  }, [setTooltipDisabled]);

  return (
    <PillarContainer>
      {/* FIXME: react/jsx-props-no-spreading */}
      {/* eslint-disable-next-line react/jsx-props-no-spreading */}
      <PillarInnerContainer {...props}>
        <PillarText
          ref={textRef}
          data-tip-disable={tooltipDisabled}
          data-tip={children}
          data-for="tooltip-for-url-selector"
        >
          {children}
        </PillarText>
        <PillarCloseButton onClick={() => !disabled && onDelete()}>
          <PillarIcon color={tokens.color.text_disabled} icon="x" size={12} disabled={disabled} />
        </PillarCloseButton>
      </PillarInnerContainer>
    </PillarContainer>
  );
};
